import type { SpatialBookmark } from '@/types';
import type { ObjectRendererProps } from './types';
import styles from '../ObjectView.module.css';

const hostOf = (url: string): string => {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
};

const isSafe = (url: string): boolean => /^https?:\/\//i.test(url);

export const BookmarkRenderer = ({ object: bm }: ObjectRendererProps<SpatialBookmark>) => (
  <div className={styles.tile}>
    <strong className={styles.tileTitle}>{bm.title || bm.name}</strong>
    {bm.description && <span className={styles.tileMeta}>{bm.description}</span>}
    {isSafe(bm.url) ? (
      <a
        className={styles.tileLink}
        href={bm.url}
        target="_blank"
        rel="noopener noreferrer"
        onPointerDown={(e) => {
          e.stopPropagation();
        }}
      >
        {hostOf(bm.url)}
      </a>
    ) : (
      <span className={styles.tileMeta}>blocked link</span>
    )}
  </div>
);
